<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">交易单管理</el-breadcrumb-item>
                <el-breadcrumb-item>付款信息</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="right">
                <div class="inline-block" v-if="voucher.contractNo != null && voucher.contractNo != ''">
                    <button class="swb-btn swb-btn-link mr15" @click.stop="monitoringData">合同数据监控</button>
                    <!--<button class="swb-btn swb-btn-link mr15" @click.stop="toTrackPhase">合同履约跟踪计划</button>-->
                </div>
                <button class="swb-btn swb-btn-link" @click="$router.back(-1)"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
            </div>
        </div>
        <div class="form-info">
            <div class="form-row">
                <div class="form-label" style="width: 145px">
                    <label>交易单号</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{voucher.no}}</span>
                    </div>
                </div>
            </div>
            <div v-if="voucher.contractNo != null && voucher.contractNo != ''">
                <div class="form-row">
                    <div class="form-label" style="width: 145px">
                        <label>系统合同编号</label>
                    </div>
                    <div class="form-value">
                        <div class="value">
                            <span>{{voucher.contractNo}}</span>
                        </div>
                    </div>
                </div>
                <hr class="dashed"/>
                <div class="form-row">
                    <div class="form-label" style="width: 145px">
                        <label>预计交易总金额(元)</label>
                    </div>
                    <div class="form-value">
                        <div class="value">
                            <span>{{(parseFloat(voucher.estmtAmount || 0)).toFixed(2)}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="form-label" style="width: 145px">
                    <label>累计订单金额(元)</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{(parseFloat(voucher.totalZxAmount || 0)).toFixed(2)}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label" style="width: 145px">
                    <label>累计收款金额(元)</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{(parseFloat(voucher.paidAmount || 0)).toFixed(2)}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label" style="width: 145px">
                    <label>实际收款金额(元)</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{(parseFloat(voucher.paidAmountX || 0)).toFixed(2)}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label" style="width: 145px">
                    <label>申请中金额(元)</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{(parseFloat(voucher.applingPayAmount || 0)).toFixed(2)}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label" style="width: 145px">
                    <label>已退款金额(元)</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{(parseFloat(voucher.refundedAmount || 0)).toFixed(2)}}</span>
                    </div>
                </div>
            </div>
            <hr class="dashed"/>
            <div v-if="voucher.contractNo != null && voucher.contractNo != '' && voucher.contractKind != contractKindFrameVal">
                <div v-if="voucher.trackPhaseFlag">
                    <div class="form-row">
                        <div class="form-label" style="width: 145px">
                            <label>所处合同阶段</label>
                        </div>
                        <div class="form-value">
                            <div class="value">
                                <el-select placeholder="请选择" class="fl" v-model="trackPhaseId" @change="trackPhaseChange(trackPhaseId)" :clearable=true>
                                    <el-option v-for="contractTrackPhase in contractTrackPhaseList" :key="contractTrackPhase.id" :label="contractTrackPhase.name" :value="contractTrackPhase.id+''"></el-option>
                                </el-select>
                                <span class="ml10" v-if="voucher.trackPhaseState != null && !voucher.colorFlag">{{voucher.trackPhaseState}}</span>
                                <span class="ml10 font-red" v-if="voucher.trackPhaseState != null && voucher.colorFlag">{{voucher.trackPhaseState}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label" style="width: 145px">
                            <label>阶段计划金额(元)</label>
                        </div>
                        <div class="form-value">
                            <div class="value">
                                <span>{{(parseFloat(voucher.amountPay || 0)).toFixed(2)}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label" style="width: 145px">
                            <label>阶段应收金额(元)</label>
                        </div>
                        <div class="form-value">
                            <div class="value">
                                <span>{{(parseFloat(voucher.shouldPay || 0)).toFixed(2)}}</span>
                                <span class="ml20" v-if="voucher.payDueTime != null && voucher.shouldPay > 0 && !voucher.payDueTimeColor">应付日期：{{voucher.payDueTime}}</span>
                                <span class="ml20 font-red" v-if="voucher.payDueTime != null && voucher.shouldPay > 0 && voucher.payDueTimeColor">应付日期：{{voucher.payDueTime}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label" style="width: 145px">
                            <label>所处阶段已收金额(元)</label>
                        </div>
                        <div class="form-value">
                            <div class="value">
                                <span>{{(parseFloat(voucher.trackPaidAmount || 0)).toFixed(2)}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label" style="width: 145px">
                            <label>所处阶段已退金额(元)</label>
                        </div>
                        <div class="form-value">
                            <div class="value">
                                <span>{{(parseFloat(voucher.trackRefundAmount || 0)).toFixed(2)}}</span>
                            </div>
                        </div>
                    </div>
                    <hr class="dashed"/>
                    <!--<div class="form-row">
                        <div class="form-label" style="width: 145px">
                            <label>所处合同阶段</label>
                        </div>
                        <div class="form-value">
                            <div class="value">
                                <span>{{voucher.trackPhaseName}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label" style="width: 145px">
                            <label>阶段计划金额(元)</label>
                        </div>
                        <div class="form-value">
                            <div class="value">
                                <span>{{(parseFloat(voucher.amountPay || 0)).toFixed(2)}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label" style="width: 145px">
                            <label>阶段应付金额(元)</label>
                        </div>
                        <div class="form-value">
                            <div class="value">
                                <span v-if="voucher.shouldPay > 0">{{voucher.shouldPay.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label" style="width: 145px">
                            <label>所处阶段已付金额(元)</label>
                        </div>
                        <div class="form-value">
                            <div class="value">
                                <span>{{(parseFloat(voucher.trackPaidAmount || 0)).toFixed(2)}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label" style="width: 145px">
                            <label>所处阶段已退金额(元)</label>
                        </div>
                        <div class="form-value">
                            <div class="value">
                                <span>{{(parseFloat(voucher.trackRefundAmount || 0)).toFixed(2)}}</span>
                            </div>
                        </div>
                    </div>
                    <hr class="dashed" />-->
                </div>
            </div>
            <div class="form-row" v-if="voucher.payPhaseTplId != null && voucher.payPhaseTplId != -1">
                <div class="form-label" style="width: 145px">
                    <label>收款阶段模板</label>
                </div>
                <div class="form-value">
                    <span>{{voucher.payPhaseTplName}}</span>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label" style="width: 145px">
                    <label>是否收款完毕</label>
                </div>
                <div class="form-value">
                    <div class="value" v-if="voucher.payFinished">是</div>
                    <div class="value" v-else>否</div>
                </div>
            </div>
            <div class="form-row" v-if="!voucher.payFinished">
                <div class="form-label">
                    <label>是否申请预付</label>
                </div>
                <div class="form-value width-2x">
                    <el-radio-group v-model="showFlag" @change="radioChange();">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div v-if="showFlag">
                <div class="form-row" v-if="voucher.payPhaseTplId != null && voucher.payPhaseTplId != -1">
                    <div class="form-label">
                        <label class="required">当前阶段</label>
                    </div>
                    <div class="form-value">
                        <el-input class="bottom-line width-2x" v-model="voucher.payPhaseName" :disabled="true"></el-input>
                        <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择付款阶段" @click="selectPayPhaseTplItem()"></i>
                    </div>
                </div>
                <div class="form-row" v-if="voucher.payPhaseTplId != null && voucher.payPhaseTplId != -1">
                    <div class="form-label">
                        <label class="required">阶段比例(%)</label>
                    </div>
                    <div class="form-value">
                        <span>{{voucher.ratio || ''}}</span>
                    </div>
                </div>
                <!--<div class="btn-row">-->
                <!--<a class="swb-btn swb-btn-small" @click="selectTradeBizItem()">选择交易明细</a>-->
                <!--<a class="swb-btn swb-btn-small" @click="selectPayPhaseTplItem()" v-if="voucher.payPhaseTplId != null && voucher.payPhaseTplId != -1 && selectTradeBizItems.length > 0">选择付款阶段</a>-->
                <!--<span class="ml30" v-if="voucher.payPhaseId != null">当前阶段：{{voucher.payPhaseName || ''}}</span>-->
                <!--<span class="ml30" v-if="voucher.payPhaseId != null">阶段比例(%)：{{voucher.ratio || ''}}</span>-->
                <!--</div>-->
                <!--<el-table :data="selectTradeBizItems" border style="width: 100%">-->
                <!--<el-table-column align="center" prop="bizNo" label="单据号" width="160"></el-table-column>-->
                <!--<el-table-column align="center" prop="tradeNo" label="交易单号"></el-table-column>-->
                <!--<el-table-column align="center" prop="contractNo" label="合同单号"></el-table-column>-->
                <!--<el-table-column align="center" prop="tradeType" label="交易类型" width="120">-->
                <!--<template slot-scope="scope">-->
                <!--<span>{{tradeTypeMap[scope.row.tradeType]}}</span>-->
                <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column align="center" prop="bizFlag" label="交易项类型" width="120">-->
                <!--<template slot-scope="scope">-->
                <!--<span>{{bizFlagMap[scope.row.bizFlag]}}</span>-->
                <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column align="right" prop="amount" label="总金额(元)" width="120">-->
                <!--<template slot-scope="scope">-->
                <!--<span>{{(scope.row.amount || 0).toFixed(2)}}</span>-->
                <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column align="right" prop="amountPaid" label="已收款金额(元)" width="150">-->
                <!--<template slot-scope="scope">-->
                <!--<span>{{(scope.row.amountPaid || 0).toFixed(2)}}</span>-->
                <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column align="right" prop="amountOwed" label="未收款金额(元)" width="150">-->
                <!--<template slot-scope="scope">-->
                <!--<span>{{(scope.row.amountOwed || 0).toFixed(2)}}</span>-->
                <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column align="right" prop="currAmount" label="本次申请金额(元)" width="150">-->
                <!--<template slot-scope="scope" :rules="{validator: checkCurrAmount, trigger: 'blur'}">-->
                <!--<input class="align-right" type="number" size="4" @change="currAmountChangeEvent(scope.row)" v-model="scope.row.currAmount" style="width: 95%"/>-->
                <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column align="center" label="操作">-->
                <!--<template slot-scope="scope">-->
                <!--<a class="swb-btn-link" @click="removeTradeBizItem(scope.$index)">移除</a>-->
                <!--<a class="swb-btn-link" @click="paidItem(scope.row)">收款详情</a>-->
                <!--</template>-->
                <!--</el-table-column>-->
                <!--</el-table>-->

                <el-form :model="voucher" :rules="checkPay" ref="ruleForm" class="demo-ruleForm">
                    <div class="form-row">
                        <div class="form-label" style="width: 145px">
                            <label class="required">申请金额(元)</label>
                        </div>
                        <div class="form-value mb15">
                            <div class="value">
                                <el-form-item prop="payAmount">
                                    <el-input v-model="voucher.payAmount" @change="payAmountChange"></el-input>
                                    <!--<div v-else class="width-1-5x">-->
                                    <!--<span>{{voucher.payAmount}}</span>-->
                                    <!--</div>-->
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label" style="width: 145px">
                            <label class="required">支付主题</label>
                        </div>
                        <div class="form-value">
                            <div class="value">
                                <el-form-item prop="subject">
                                    <el-input v-model="voucher.subject"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label">
                            <label class="required">付款形式</label>
                        </div>
                        <div class="form-value">
                            <div class="value">
                                <el-form-item prop="payForm">
                                    <el-radio-group v-model="voucher.payForm">
                                        <el-radio v-for="item in payFormList" :label="item.value">
                                            <span>{{item.text}}</span>
                                        </el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label" style="width: 145px">
                            <label>申请描述</label>
                        </div>
                        <div class="form-value">
                            <el-form-item prop="applyDesc">
                                <textarea class="width-2x" placeholder="请输入" v-model="voucher.applyDesc"></textarea>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-label" style="width: 145px">
                            <label>备注</label>
                        </div>
                        <div class="form-value">
                            <el-form-item prop="memo">
                                <textarea class="width-2x" placeholder="请输入" v-model="voucher.memo"></textarea>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
                <div class="form-toolbar">
                    <button class="swb-btn" @click="applyPayOption();">预付申请</button>
                </div>
            </div>
            <div class="form-toolbar" v-if="checkActionPerm('pay_finished') && !voucher.payFinished && !showFlag">
                <button class="swb-btn" @click="payFinishedOption();">收款完毕</button>
            </div>
        </div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="payVoucherList" border tooltip-effect="dark" style="width: 100%">
                <el-table-column prop="no" label="支付单号" width="160px;" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="prePayFlag" label="预付" width="80px;" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span class="font-red" v-if="rows.row.prePayFlag">预付</span>
                    </template>
                </el-table-column>
                <el-table-column prop="staffLoan" label="员工借款" width="80px;" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span class="font-red" v-if="rows.row.staffLoan">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="tradeNo" label="交易单号" width="160px;" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="settleProofNo" label="结算单号" width="160px;" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="buyerName" label="客户名称" width="200px;" show-overflow-tooltip></el-table-column>
                <el-table-column prop="subject" label="支付主题" width="190px;" show-overflow-tooltip></el-table-column>
                <el-table-column prop="payWayText" label="支付方式" align="center"></el-table-column>
                <el-table-column prop="amount" label="支付金额(元)" width="130px;" align="right">
                    <template slot-scope="rows">
                        <span v-if="rows.row.prePayFlag">{{(rows.row.amountPre || 0).toFixed(2)}}</span>
                        <span v-else>{{rows.row.amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="payResultText" label="支付结果" width="100px;"></el-table-column>
                <el-table-column prop="createTime" label="创建日期" width="160px;" align="center"></el-table-column>
                <el-table-column prop="creatorMerchantTypeText" label="创建者商户类型" width="110px;" align="center">
                    <template slot-scope="rows">
                                <span>
                                    {{merchantTypeMap[rows.row.creatorMerchantType]}}
                                </span>
                    </template>
                </el-table-column>
                <el-table-column prop="creatorMerchantName" label="创建者商户名称" width="200px;" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout" v-if="totalCount > 10">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'
    import { CtrlParamCodes } from '../../app.const'
    //    import { openSettlePayItemListDlg } from '../settle/showDlg'
    import { openPayPhaseTplItemListForSelectDlg } from '../payPhase/showDlg'

    import tradeApi from '../../api/trade'
    import finacApi from '../../api/finac'
    import merchtComnApi from '../../api/merchtComn'
    import contractApi from '../../api/contract'

    // 合同监控
    import SwbContractDataMonitoring from '../contract/ContractDataMonitoring';
    Vue.regist(SwbContractDataMonitoring);
    // 合同履约跟踪计划
    import SwbContractTrackPhase from '../contract/ContractTrackPhase';
    Vue.regist(SwbContractTrackPhase);

    import SwbTradeVoucherList from './TradeVoucherList';
    Routes.add(SwbTradeVoucherList);

    export default{
        name: 'swb-trade-voucher-payment-info',
        path: '/trade/payment/info',
        avlActions: '',
        avlScopes: 'servicer',
        desc: '交易单付款信息',
        notAsResc: true,
        authen: false,
        data: function () {
            // 校验
            let self = this;
            let payAmount = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('申请金额不能为空'));
                } else {
                    if(!Utils.isMoneyStr(value)) {
                        callback(new Error('必须是金额'));
                    } else {
                        let val = parseFloat(value);
                        if(val <= 0) {
                            callback(new Error('申请金额必须大于0'));
                        } else {
                            let regex = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
                            if(regex.test(val)) {
                                let estmtAmount = self.voucher.estmtAmount;
                                let contractKind = self.voucher.contractKind;
                                if(!Utils.isNoB(self.voucher.orderNo) || contractKind == self.contractKindFrameVal) {
                                    estmtAmount = self.voucher.totalZxAmount;
                                }
                                if(!Utils.isNoB(estmtAmount) && contractKind != self.contractKindFrameVal) {
                                    let totalPay = self.voucher.appliedPayAmount + val;
                                    if(totalPay > estmtAmount) {
                                        callback(new Error('该金额超过了可以申请的金额'));
                                    } else {
                                        callback();
                                    }
                                } else {
                                    callback();
                                }
                            } else {
                                callback(new Error('输入的金额不能超过两位小数'));
                            }
                        }
                    }
                }
            };
            let checkSubject = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('支付主题不能为空'));
                } else {
                    callback();
                }
            };
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                voucher: {
                    payForm: getEnumInfoWith("payForm", "name", "Trans").value,
                    staffLoan: false
                },
                tradeId: null,
                payVoucherList: [],
                contractTrackPhaseList: [],
                trackPhaseId: null,
                trackPhaseName: null,
                payPhaseId: null, // 付款阶段id
                merchantTypeMap: getEnumMap("merchantType", "value2text"),
                contractKindFrameVal: getEnumInfoWith('contractKind', 'name', 'Frame').value,
                payFormList: getEnumList("payForm"),
                showFlag: false,
                tradeTypeMap: {},
                bizFlagMap: {},
                // 校验
                checkPay: {
                    payAmount: [{
                        validator: payAmount,
                        trigger: 'blur'
                    }],
                    subject: [{
                        validator: checkSubject,
                        trigger: 'blur'
                    }],
                }
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.tradeId = this.$route.query.tradeId || null;
            //
            this.tradeTypeMap = getEnumMap("tradeType", "value2text");
            this.bizFlagMap = getEnumMap("bizFlag", "value2text");
            //
            this.getPayVoucherList();
        },
        methods: {
            //
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(SwbTradeVoucherList.path, action, targetPostId);
            },
            // 已支付详情
//            paidItem: function (row) {
//                let params = {
//                    filter: {
//                        tradeId: row.tradeId,
//                        bizItemId: row.id
//                    }
//                };
//                openSettlePayItemListDlg(params);
//            },
            payAmountChange: function () {
                let voucher = this.voucher || {};
                if(!Utils.isNoB(voucher.payAmount)) {
                    voucher.payAmount = parseFloat(voucher.payAmount).toFixed(2);
                }
                this.voucher = Utils.merge({}, voucher);
            },
            // 交易单详情
            getVoucherDetail: function (id) {
                let self = this;
                let postData = {};
                postData.id = id;
                tradeApi.getTradeVoucher(postData, function (result) {
                    if(result.type == 'info') {
                        self.voucher = result.data || {};
                        self.voucher.applingPayAmount = self.voucher.appliedPayAmount - self.voucher.paidAmount;
                        //
                        let amount = null;
                        let estmtAmount = self.voucher.estmtAmount;
                        if(!Utils.isNoB(estmtAmount)) {
                            amount = estmtAmount;
                        } else {
                            amount = self.voucher.totalZxAmount;
                        }
                        if(Utils.isNoB(amount)) {
                            amount = 0;
                        }
                        let payAmount = amount - self.voucher.appliedPayAmount;
                        if(payAmount < 0) {
                            self.voucher.payAmount = '0.00';
                        } else {
                            self.voucher.payAmount = payAmount.toFixed(2);
                        }
                        // 阶段应付金额
                        self.voucher.shouldPay = parseFloat(self.voucher.amountPay || 0) - parseFloat(self.voucher.trackPaidAmount || 0);
                        //
                        if(!Utils.isNoB(self.voucher.orderNo)) {
                            self.voucher.subject = self.voucher.orderNo;
                        }
                        if(!Utils.isNoB(self.voucher.contractNo)) {
                            self.voucher.subject = self.voucher.contractNo;
                        }
                        //
                        if(!Utils.isNoB(self.voucher.contractId) && self.voucher.trackPhaseFlag) {
                            let reqDate = {};
                            reqDate.contractId = self.voucher.contractId;
                            contractApi.getContractTrackPhaseListByContractId(reqDate, function (result) {
                                if(result.type == 'info') {
                                    self.contractTrackPhaseList = result.data;
                                    if(!Utils.isNoB(self.contractTrackPhaseList) && self.contractTrackPhaseList.length > 0) {
                                        if(!Utils.isNoB(self.voucher.trackPhaseId)) {
                                            self.trackPhaseId = self.voucher.trackPhaseId + '';
                                            self.trackPhaseChange(self.voucher.trackPhaseId);
                                        }
                                    }
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            })
                        }
                        //
                        self.voucher.payForm = getEnumInfoWith("payForm", "name", "Trans").value;
                        self.voucher.staffLoan = false;
                        self.voucher = Utils.merge({}, self.voucher);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 选择付款阶段
            selectPayPhaseTplItem: function () {
                let self = this;
                let voucher = self.voucher || {};
                let checkedIds = [];
                if(!Utils.isNoB(voucher.payPhaseId)) {
                    checkedIds.push(voucher.payPhaseId);
                }
                let params = {
                    tplId: voucher.payPhaseTplId,
                    checkedIds: checkedIds
                };
                openPayPhaseTplItemListForSelectDlg(params, function (payPhaseTplItem, theDlg) {
                    theDlg.close();
                    voucher.payPhaseId = payPhaseTplItem.id;
                    voucher.payPhaseName = payPhaseTplItem.name;
                    voucher.ratio = parseFloat(payPhaseTplItem.ratio).toFixed(2);
                    //
                    self.voucher = Utils.merge({}, voucher);
                });
            },
            // 分页信息
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getPayVoucherList();
            },
            // 支付单据列表
            getPayVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                if(!Utils.isNoB(self.tradeId)) {
                    filterItems.tradeId = self.tradeId;
                }
                filterItems.directFlag = getEnumInfoWith('directFlag', 'name', 'Forward').value;
                postData.filterItems = filterItems;
                //
                let msgBoxDlg = MsgBox.loading();
                finacApi.getRcvVoucherCOList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let payVoucherList = result.data.rows || [];
                        if(!Utils.isNoB(payVoucherList) && payVoucherList.length > 0) {
                            for(let i = 0; i < payVoucherList.length; i++) {
                                let payVoucher = payVoucherList[i];
                                payVoucher.amount = payVoucher.amount.toFixed(2);
                                //
                                let payWayInfo = getEnumInfoWith('payWay', 'value', payVoucher.payWay);
                                if(payWayInfo != null) {
                                    payVoucher.payWayText = payWayInfo.text;
                                }
                                //
                                let resultStateInfo = getEnumInfoWith('resultState', 'value', payVoucher.payResult);
                                if(resultStateInfo != null) {
                                    if(resultStateInfo.name == "Failure") {
                                        payVoucher.payResultText = "支付失败";
                                    } else if(resultStateInfo.name == "Success") {
                                        payVoucher.payResultText = "支付成功";
                                    } else {
                                        payVoucher.payResultText = "待支付";
                                    }
                                }
                            }
                        }
                        self.payVoucherList = Utils.merge([], payVoucherList);
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                    //
                    self.getVoucherDetail(self.tradeId);
                })
            },
            // 阶段变化事件
            trackPhaseChange: function (trackPhaseId) {
                let self = this;
                let contractTrackPhaseList = self.contractTrackPhaseList;
                if(!Utils.isNoB(contractTrackPhaseList) && contractTrackPhaseList.length > 0) {
                    //
                    for(let i = 0; i < contractTrackPhaseList.length; i++) {
                        let contractTrackPhase = contractTrackPhaseList[i];
                        if(contractTrackPhase.id == trackPhaseId) {
                            //
                            self.trackPhaseName = contractTrackPhase.name;
                            //
                            let params = {};
                            params.trackPhaseId = trackPhaseId;
                            finacApi.getAmountByTrackPhaseId(params, function (result) {
                                if(result.type == 'info') {
                                    let map = result.data;
                                    let amountPay = contractTrackPhase.amountPay;
                                    if(Utils.isNoB(amountPay)) {
                                        amountPay = 0;
                                    }
                                    self.voucher.amountPay = amountPay;
                                    self.voucher.trackPaidAmount = map.payAmount;
                                    self.voucher.trackRefundAmount = map.refundAmount;
                                    self.voucher.applingPayAmount = map.applingAmount;
                                    if(self.voucher.trackPaidAmount == 0) {
                                        self.voucher.payAmount = self.voucher.amountPay;
                                    } else if(self.voucher.trackPaidAmount < amountPay) {
                                        self.voucher.payAmount = self.voucher.amountPay - self.voucher.trackPaidAmount;
                                    } else {
                                        let estmtAmount = self.voucher.estmtAmount;
                                        if(Utils.isNoB(estmtAmount)) {
                                            estmtAmount = 0;
                                        }
                                        self.voucher.payAmount = estmtAmount - self.voucher.appliedPayAmount;
                                    }
                                    if(!Utils.isNoB(self.voucher.payAmount)) {
                                        self.voucher.payAmount = parseFloat(self.voucher.payAmount).toFixed(2);
                                    }
                                    // 阶段状态
                                    if(!contractTrackPhase.deliverFinished && contractTrackPhase.active) {
                                        self.voucher.trackPhaseState = '当前阶段，交付未完成';
                                        self.voucher.colorFlag = true;
                                        self.voucher.shouldPay = 0;
                                    } else if(!contractTrackPhase.deliverFinished && !contractTrackPhase.active) {
                                        self.voucher.trackPhaseState = '阶段未开始';
                                        self.voucher.colorFlag = true;
                                        self.voucher.shouldPay = 0;
                                    } else if(contractTrackPhase.deliverFinished && !contractTrackPhase.active) {
                                        self.voucher.trackPhaseState = '交付完成';
                                        self.voucher.colorFlag = false;
                                        // 阶段应付金额
                                        if(Utils.isNoB(contractTrackPhase.payDueTime)) {
                                            self.voucher.shouldPay = 0;
                                        } else {
                                            self.voucher.shouldPay = self.voucher.amountPay - self.voucher.trackPaidAmount;
                                        }
                                    }
                                    // 阶段应付日期
                                    if(!Utils.isNoB(contractTrackPhase.payDueTime)) {
                                        contractTrackPhase.payDueTime = new Date(contractTrackPhase.payDueTime).format('yyyy-MM-dd');
                                        let currentDate = new Date();
                                        if(contractTrackPhase.payDueTime < currentDate.format('yyyy-MM-dd')) {
                                            self.voucher.payDueTimeColor = true;
                                        } else {
                                            self.voucher.payDueTimeColor = false;
                                        }
                                    } else {
                                        contractTrackPhase.payDueTime = null;
                                        self.voucher.payDueTimeColor = false;
                                    }
                                    self.voucher.payDueTime = contractTrackPhase.payDueTime;
                                    self.voucher = Utils.merge({}, self.voucher);
                                }
                            })
                        }
                    }
                }
            },
            // radio变化事件
            radioChange: function () {
                let self = this;
                if(self.showFlag && self.voucher.auditState != 1) {
                    MsgBox.warning("审核未通过,不能进行该操作！");
                    self.showFlag = false;
                }
            },
            // 申请催款
            applyPayOption: function () {
                let self = this;
                if(self.showFlag) {
                    let voucher = self.voucher;
                    if(!Utils.isNoB(voucher.payPhaseTplId) && voucher.payPhaseTplId != -1 && Utils.isNoB(voucher.payPhaseId)) {
                        MsgBox.warning("请选择付款阶段!");
                        return;
                    }
                    let payVoucher = {};
                    //
                    payVoucher.directFlag = getEnumInfoWith('directFlag', 'name', 'Forward').value;
                    payVoucher.tradeId = voucher.id;
                    payVoucher.tradeNo = voucher.no;
                    payVoucher.tradeType = voucher.type;
                    //
                    payVoucher.contractOriginalNo = voucher.contractOriginalNo;
                    payVoucher.contractNo = voucher.contractNo;
                    if(!Utils.isNoB(voucher.orderNo)) {
                        payVoucher.orderNo = voucher.orderNo;
                    }
                    //
                    payVoucher.trackPhaseId = voucher.trackPhaseId;
                    payVoucher.trackPhaseName = voucher.trackPhaseName;
                    //
                    payVoucher.buyerType = voucher.buyerType;
                    payVoucher.buyerId = voucher.buyerId;
                    payVoucher.buyerName = voucher.buyerName;
                    //
                    payVoucher.payPhaseId = voucher.payPhaseId;
                    payVoucher.payPhaseName = voucher.payPhaseName;
                    payVoucher.ratio = voucher.ratio;
                    payVoucher.amount = voucher.payAmount;
                    payVoucher.amountPost = voucher.payAmount;
                    //
                    payVoucher.sellerType = voucher.sellerType;
                    payVoucher.sellerVendorType = voucher.sellerVendorType;
                    payVoucher.sellerId = voucher.sellerId;
                    payVoucher.sellerName = voucher.sellerName;
                    //
                    payVoucher.subject = voucher.subject;
                    if(Utils.isNoB(payVoucher.contractNo)) {
                        payVoucher.payWay = getEnumInfoWith("payWay", "name", "Offline").value;
                        // 交易单已支付金额
                        payVoucher.paidAmount = voucher.paidAmount;
                    } else {
                        payVoucher.payWay = voucher.payWay;
                    }
                    //
                    payVoucher.payDays = voucher.payDays;
                    payVoucher.payStartTime = voucher.payStartTime;
                    payVoucher.payDueTime = voucher.payDueTime;
                    payVoucher.yjRatio = voucher.yjRatio;
                    payVoucher.yjFeeChargeMode = voucher.yjFeeChargeMode;
                    payVoucher.yjPayDays = voucher.yjPayDays;
                    //
                    payVoucher.payForm = voucher.payForm;
                    payVoucher.staffLoan = voucher.staffLoan;
                    payVoucher.memo = voucher.memo;
                    payVoucher.applyDesc = voucher.applyDesc;
                    //
                    payVoucher.showFlag = self.showFlag;
                    // 表单校验
                    self.$refs['ruleForm'].validate(function (valid) {
                        if(valid) {
                            //
                            let lastMsgBoxDlg = MsgBox.loading();
                            finacApi.savePayVoucher(payVoucher, function (result) {
                                if(result.type == 'info') {
                                    setTimeout(function () {
                                        lastMsgBoxDlg.close();
                                        MsgBox.success("申请成功");
                                        self.showFlag = false;
                                        self.voucher.subject = null;
                                        self.voucher.applyDesc = null;
                                        self.voucher.memo = null;
                                        self.getPayVoucherList();
                                        self.getVoucherDetail(self.tradeId);
                                    }, 3000);
                                } else {
                                    MsgBox.warning("申请失败");
                                    lastMsgBoxDlg.close();
                                }
                            });
                        } else {
                            if(voucher.payAmount <= 0) {
                                MsgBox.warning("申请金额必须大于0");
                            } else if(Utils.isNoB(voucher.subject)) {
                                MsgBox.warning("支付主题不能为空");
                            } else {
                                let amount = voucher.appliedPayAmount + voucher.payAmount;
                                if(amount > voucher.totalZxAmount) {
                                    self.$confirm('申请金额超过了可以申请的金额，确定要继续申请预付吗', '提示', {
                                        confirmButtonText: '确定',
                                        cancelButtonText: '取消',
                                        type: 'warning'
                                    }).then(function () {
                                        let lastMsgBoxDlg = MsgBox.loading();
                                        finacApi.savePayVoucher(payVoucher, function (result) {
                                            if(result.type == 'info') {
                                                setTimeout(function () {
                                                    lastMsgBoxDlg.close();
                                                    MsgBox.success("申请成功");
                                                    self.showFlag = false;
                                                    self.voucher.subject = null;
                                                    self.voucher.applyDesc = null;
                                                    self.voucher.memo = null;
                                                    self.getPayVoucherList();
                                                    self.getVoucherDetail(self.tradeId);
                                                }, 3000);
                                            } else {
                                                MsgBox.warning("申请失败");
                                                lastMsgBoxDlg.close();
                                            }
                                        });
                                    }).catch(function () {
                                    });
                                }
                            }
                        }
                    });
                }
            },
            // 支付完成
            payFinishedOption: function () {
                let self = this;
                self.$confirm('确定要执行该操作吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = self.tradeId;
                    //
                    let msgBoxDlg = MsgBox.loading();
                    tradeApi.finishTradeVoucherPay(postData, function (result) {
                        msgBoxDlg.close();
                        if(result.type === "info") {
                            MsgBox.success("操作成功");
                            self.getPayVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 合同数据监控
            monitoringData: function () {
                let theVipLevel = merchtComnApi.checkCtxMerchantVipLevel(CtrlParamCodes.VIP_VALVE_FOR_CONTRACT_PHASE_TRACK);
                if(theVipLevel != null) {
                    MsgBox.warning(theVipLevel);
                    return;
                }
                let self = this;
                Vue.$showDialog({
                    title: '合同数据监控',
                    showCloseBtn: true,
                    okVisible: false,
                    width: 1450,
                    height: 600,
                    template: '<div>' +
                    '<swb-contract-data-monitoring :contractId = "contractId" :contractNo="contractNo" :contractType="type" ref="swb_contract_data_monitoring"></swb-contract-data-monitoring>' +
                    '</div>',
                    data: {
                        contractId: null,
                        contractNo: null,
                        type: null
                    },
                    methods: {},
                    okClicked: function () {

                    },
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            selfDlg.contractId = self.voucher.contractId;
                            selfDlg.contractNo = self.voucher.contractNo;
                            selfDlg.type = self.voucher.contractType;
                        }
                    }
                });
            },
            // 合同履约跟踪计划
            toTrackPhase: function () {
                let self = this;
                Vue.$showDialog({
                    title: '合同履约跟踪计划',
                    showCloseBtn: true,
                    okVisible: false,
                    width: 1150,
                    template: '<div>' +
                    '<swb-contract-track-phase :contractId = "contractId" :signDate = "signDate" :contractType="type" :trackPhaseList="trackPhaseList" :operate="operateContract" ref="swb_contract_track_phase"></swb-contract-track-phase>' +
                    '</div>',
                    data: {
                        contractId: null,
                        signDate: null,
                        type: null,
                        operateContract: null,
                        trackPhaseList: []
                    },
                    methods: {},
                    okClicked: function () {
                    },
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            selfDlg.contractId = self.voucher.contractId;
                            selfDlg.signDate = self.voucher.signDate;
                            selfDlg.type = self.voucher.contractType;
                            selfDlg.operateContract = 'chakan';
                            selfDlg.trackPhaseList = self.voucher.contractTrackPhaseList || [];
                        }
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/tradeVoucher/TradeVoucherPaymentInfo.vue